module.exports = __webpack_public_path__ + "static/media/值得一辈子去爱（纪如景）.ee1b0fe6.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/static/music/值得一辈子去爱（纪如景）.mp3
// module id = 488
// module chunks = 0